<template>
  <DialogComponent
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
    v-loading="processing"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">
          View / Edit Port Request
        </h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="submitEditOrder" v-if="editMade"
            >Submit</el-button
          >
          <el-button type="default" @click="cancelOperation"> Cancel</el-button>
        </div>
      </div>
    </div>
    <el-form>
      <recent-audits :record="selectedPortOrder" service="Port Request" />

      <div v-if="!processing" class="mb-10">
        <h2 class="form-section-header ">
          Order number summary -
          {{ selectedPortOrder ? selectedPortOrder.id : "" }}
        </h2>
      </div>

      <vxe-grid
        class="vxe-table mt-10"
        round
        border="inner"
        ref="xGrid"
        height="250px"
        auto-resize
        empty-text="No Data"
        show-overflow="tooltip"
        highlight-hover-row
        :data="allSummaryNumbers"
        :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
        :columns="tableColumnsEdit"
      />
    </el-form>
    <div class="order-note mt-10">
      <el-button
        class="table-action-button"
        icon="el-icon-edit"
        @click="noteFieldActive = !noteFieldActive"
      />
      <span class="black-text pl-10">Add order note</span>
      <el-input
        type="textarea"
        placeholder="Enter order notes"
        v-if="noteFieldActive"
        v-model="editNumberForm.orderNote"
        @change="editedOrderNote"
        :autosize="{ minRows: 4 }"
      >
      </el-input>
    </div>
    <div class="order-notes" v-if="editNumberForm.orderNotes">
      <el-button
        class="table-action-button"
        icon="el-icon-tickets"
        @click="viewNotesActive = !viewNotesActive"
      />
      <span class="black-text pl-10">View order notes</span>
      <div class="notes-container" v-if="viewNotesActive">
        <div
          class="note-item black-text"
          v-for="note in editNumberForm.orderNotes"
          :key="note.noteId"
        >
          <p class="note-message">
            {{ note.insertUser }} - {{ note.insertDate }}
            <br />
            <span class="pt-5">{{ note.note }}</span>
          </p>
        </div>
      </div>
    </div>

    <div v-if="canBeSupped && orderStatus === 'Pending'">
      <h2 class="form-section-header mb-10">
        Edit requested port date - {{ editNumberForm.currentPortDate }}
      </h2>
      <div class="inline-form-group">
        <el-col :span="9">
          <el-date-picker
            v-model="editNumberForm.portDate"
            type="date"
            :editable="false"
            :picker-options="datePickerOptions"
            @change="editedPortDate"
            placeholder="New desired port date"
          />
        </el-col>
      </div>
    </div>

    <div class="port-edit-container" v-show="orderIsEditable">
      <div v-show="editNumberFormVisible">
        <h2 class="form-section-header">
          Edit order details -
          {{ prettyNumber(editNumberForm.telephoneNumber) }}
        </h2>
        <div class="inline-form-group">
          <el-col :span="9">
            <el-tooltip
              class="item"
              effect="dark"
              content="This is the person that is authorized to make changes on the account"
              placement="top"
            >
              <el-input
                v-model="editNumberForm.authName"
                placeholder="Enter authorized person"
              >
                <template slot="prefix">Authorized person</template>
              </el-input>
            </el-tooltip>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="8">
            <el-tooltip
              class="item"
              effect="dark"
              content="Account number is only required if it is displayed on your monthly bill"
              placement="top"
            >
              <el-input
                v-model="editNumberForm.accountNum"
                placeholder="Enter account number"
              >
                <template slot="prefix">Account #</template>
              </el-input>
            </el-tooltip>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="6">
            <el-tooltip
              class="item"
              effect="dark"
              content="Pin number for the account. May not be required"
              placement="top"
            >
              <el-input
                v-model="editNumberForm.accountPin"
                placeholder="Enter Account PIN"
              >
                <template slot="prefix">Account PIN</template>
              </el-input>
            </el-tooltip>
          </el-col>
        </div>
        <div class="inline-form-group">
          <el-col :span="14">
            <el-input
              v-model="editNumberForm.name"
              placeholder="Enter company name"
            >
              <template slot="prefix">Company name</template>
            </el-input>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="9">
            <el-input v-model="editNumberForm.atn" placeholder="Enter BTN">
              <template slot="prefix">BTN</template>
            </el-input>
          </el-col>
        </div>
        <el-input
          name="autoAddressEdit"
          v-model="address"
          placeholder="Search for address"
        >
          <template slot="prefix">Search address</template>
        </el-input>
        <div class="address-fields">
          <div class="inline-form-group">
            <el-col :span="8">
              <el-input
                v-model="editNumberForm.streetNum"
                placeholder="Enter street #"
              >
                <template slot="prefix">Street number</template>
              </el-input>
            </el-col>
            <el-col :span="1"></el-col>
            <el-col :span="15">
              <el-input
                v-model="editNumberForm.streetInfo"
                placeholder="Enter street name"
              >
                <template slot="prefix">Street name</template>
              </el-input>
            </el-col>
          </div>
          <div class="inline-form-group">
            <el-col :span="8">
              <el-select
                v-model="editNumberForm.locationType"
                :value="editNumberForm.locationType"
                placeholder="Location Type"
              >
                <template slot="prefix">Building / Suite</template>
                <el-option
                  v-for="(location, index) in locationOptions"
                  :key="index"
                  :label="location"
                  :value="location"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="1"></el-col>
            <el-col :span="15">
              <el-input
                v-model="editNumberForm.locationNumber"
                placeholder="Enter Building/Suite #"
              >
                <template slot="prefix">Building / Suite #</template>
              </el-input>
            </el-col>
          </div>
          <div class="inline-form-group">
            <el-col :span="11">
              <el-input v-model="editNumberForm.city" placeholder="Enter City">
                <template slot="prefix">City</template>
              </el-input>
            </el-col>
            <el-col :span="1"></el-col>
            <el-col :span="5">
              <el-input
                v-model="editNumberForm.state"
                placeholder="Enter State"
              >
                <template slot="prefix">State</template>
              </el-input>
            </el-col>
            <el-col :span="1"></el-col>
            <el-col :span="6">
              <el-input
                v-model="editNumberForm.postalCode"
                placeholder="Enter Zip"
              >
                <template slot="prefix">Zip Code</template>
              </el-input>
            </el-col>
          </div>
        </div>
        <div
          class="form-comment-header black-text"
          v-if="multipleNumbersEditable"
        >
          Also apply to:
          <el-checkbox
            class="check-all"
            @change="editCheckAll"
            v-model="editNumberForm.checkAll"
            style="margin-left: 0; margin-top: 5px;"
          >
            Select all
          </el-checkbox>
        </div>
        <el-checkbox-group
          class="number-check-group"
          v-model="editNumberForm.checkedNumbers"
        >
          <template v-for="numberGroup in allSummaryNumbers">
            <div
              :key="numberGroup.telephoneNumber"
              v-if="
                editableNumber(numberGroup.tnStatus) &&
                  numberGroup.telephoneNumber !== editNumberForm.telephoneNumber
              "
              class="checkbox-item"
            >
              <el-checkbox
                :label="numberGroup.telephoneNumber"
                @change="checkOtherChange"
              >
                <span class="black-text">{{
                  prettyNumber(numberGroup.telephoneNumber)
                }}</span>
              </el-checkbox>
            </div></template
          >
        </el-checkbox-group>

        <div class="button-group">
          <el-button @click="submitNumberEdit">
            Submit Edits
          </el-button>
        </div>
      </div>
    </div>

    <div v-if="allOrderDocs && allOrderDocs.length" class="order-docs">
      <h2 class="form-section-header mt-10 mb-10">View / Download Order Documents</h2>
      <vxe-grid
        class="vxe-table"
        round
        border="inner"
        ref="xGrid"
        height="250px"
        auto-resize
        empty-text="No Data"
        show-overflow="tooltip"
        highlight-hover-row
        :data="orderDocs"
        :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
        :columns="orderDocsColumns"
        :loading="orderDocsLoading"
      />
    </div>

    <div v-if="editVisible" class="attach-docs">
      <h2 class="form-section-header">Attach documents</h2>
      <el-upload
        class="mt-10"
        action=""
        :auto-upload="false"
        :multiple="true"
        :on-change="onDocsUpload"
      >
        <el-button size="mini" type="primary">Click to upload</el-button>
      </el-upload>
    </div>
  </DialogComponent>
</template>

<script>
import { mapActions } from "vuex";

import DialogComponent from "@/components/CustomModalComponent";
import RecentAudits from "@/components/RecentAudits";
import moment from 'moment';
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "NormalPortRequestEditForm",

  props: {
    editVisible: { required: true },
    processing: { required: true },
    selectedPortOrder: { required: true },
    locationOptions: { required: true },
    datePickerOptions: { required: true },
    clearFields: { required: true }
  },

  components: {
    DialogComponent,
    RecentAudits
  },

  data() {
    return {
      editMade: false,
      orderIsEditable: false,
      noteFieldActive: false,
      viewNotesActive: false,
      editNumberFormVisible: false,
      multipleNumbersEditable: false,
      allSummaryNumbers: [],
      docs: [],
      address: "",
      addressFieldsActive: false,
      canBeSupped: false,
      orderStatus: "",

      editNumberForm: {
        accountNum: "",
        accountPin: "",
        trunkGroup: "",
        atn: "",
        authName: "",
        authDate: "",
        portDate: null,
        orderNote: "",
        currentPortDate: "",
        telephoneNumber: "",
        name: "",
        streetNum: "",
        streetInfo: "",
        locationType: "",
        locationNumber: "",
        city: "",
        state: "",
        postalCode: "",
        otherNumbersMap: [],
        checkedNumbers: [],
        checkAll: false,
        orderNotes: []
      },

      processedEdits: [],
      editedOrderData: {
        desiredDueDate: null,
        orderNote: null,
        orderId: ""
      },

      tableColumnsEdit: [
        {
          field: "telephoneNumber",
          title: "Number",
          minWidth: 150,
          sortable: true,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [<span>{this.numberFormatter(row.telephoneNumber)}</span>];
            }
          }
        },
        {
          field: "tnStatus",
          title: "Status",
          minWidth: 150,
          sortable: true,
          showOverflow: true
        },
        {
          field: "actions",
          title: "",
          minWidth: 75,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div>
                  {this.editableNumber(row.tnStatus) && (
                    <el-button
                      class="table-action-button icon blue"
                      onClick={() => this.editingNumber(row)}
                      icon="el-icon-edit"
                    />
                  )}
                </div>
              ];
            }
          }
        },
        {
          field: "check",
          title: "",
          minWidth: 75,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div>
                  {this.processedEdits.includes(row.telephoneNumber) && (
                    <div class="voxo-square-icon">
                      <v-svg class="voxo-green" sprite="check" />
                    </div>
                  )}
                </div>
              ];
            }
          }
        }
      ],

      orderDocs: [],
      allOrderDocs: [],
      orderDocsLoading: false,
      orderDocsColumns: [
        {
          field: "documentId",
          title: "Id",
          minWidth: 50,
          sortable: true,
          showOverflow: true
        },
        {
          field: "documentName",
          title: "Name",
          minWidth: 250,
          sortable: true,
          showOverflow: true
        },
        {
          field: "actions",
          title: "",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div>
                  <el-tooltip placement="top" content="Download">
                    <el-button
                      id={"edit-" + row.id}
                      icon="el-icon-download"
                      onClick={() => this.downloadDoc(row)}
                      class="table-action-button icon-blue"
                    />
                  </el-tooltip>
                </div>
              ];
            }
          }
        }
      ]
    };
  },

  watch: {
    selectedPortOrder: {
      immediate: true,
      handler(val) {
        if (val) {
          const { tnGroups, orderNotes, desiredDueDate, orderDocs, orderStatus } = val;

          console.log("Here is the order", val);

          this.orderDocs = [...orderDocs];
          this.allOrderDocs = [...orderDocs];
          this.orderStatus = orderStatus;

          this.editOrderData = [...tnGroups];
          this.allSummaryNumbers = [...tnGroups];
          this.editNumberForm.orderNotes = orderNotes;
          this.editNumberForm.currentPortDate = desiredDueDate.split("T")[0];

          let count = 0;
          const uneditableStatus = ["Complete", "Received FOC", "Canceled"];
          for (let i = 0; i < this.editOrderData.length; i++) {
            if (!uneditableStatus.includes(this.editOrderData[i].tnStatus)) {
              count++;
              this.orderIsEditable = true;
              this.canBeSupped = true;
            }
            if (count > 1) {
              this.multipleNumbersEditable = true;
              break;
            }
          }

          //need to back up 2 business days before desired due date
          if(!this.orderIsEditable && orderStatus === "Pending"){
            let days = 0;
            let dayCount = 1;
            const currentDueDate = moment(this.editNumberForm.currentPortDate);
            let validSupDate = null;
            while (days < 2){
              console.log(dayCount);
              const date = moment(currentDueDate).subtract(dayCount, 'days');
              if(date.day() > 0 && date.day() < 6){
                days++;
              }
              if(days >= 2){
                validSupDate = date;
              }
              dayCount++;
            }
            console.log(moment(validSupDate).format("YYYY-MM-DD"));
            this.canBeSupped = moment(validSupDate).format("YYYY-MM-DD") >= moment().format("YYYY-MM-DD");
            console.log(this.canBeSupped);
          }



        }
      }
    },

    clearFields: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetFields();
        }
      }
    }
  },

  methods: {
    ...mapActions("number-porting", {
      tnPortAvailability: "find"
    }),

    submitEditOrder() {
      const formData = new FormData();
      for (let key in this.editedOrderData) {
        if (
          key !== "desiredDueDate" &&
          key !== "orderId" &&
          key !== "orderNote"
        ) {
          formData.append(key, JSON.stringify(this.editedOrderData[key]));
          continue;
        }

        formData.append(key, this.editedOrderData[key]);
      }
      formData.append(
        "orderRef",
        this.selectedPortOrder.customerOrderReference
      );
      this.docs.forEach(file => {
        formData.append("docs", file.raw);
      });

      this.$emit("editOrder", formData);
    },

    downloadDoc({ documentName, fileContent, mimeType }) {
      this.orderDocsLoading = true;

      const linkSource = `data:${mimeType};base64,${fileContent}`;
      const link = document.createElement("a");
      link.href = linkSource;
      link.download = documentName;
      link.click();
      this.orderDocsLoading = false;
    },

    resetFields() {
      Object.keys(this.editNumberForm).forEach(key => {
        if (key === "portDate") {
          this.editNumberForm[key] = null;
          return;
        }

        if (key === "checkAll") {
          this.editNumberForm[key] = false;
          return;
        }

        this.editNumberForm[key] = Array.isArray(this.editNumberForm[key])
          ? []
          : "";
      });
      this.editMade = false;
      this.orderIsEditable = false;
      this.noteFieldActive = false;
      this.viewNotesActive = false;
      this.editNumberFormVisible = false;
      this.multipleNumbersEditable = false;
      this.allSummaryNumbers = [];
      this.docs = [];
      this.address = "";
      this.addressFieldsActive = false;
      this.processedEdits = [];
      this.editOrderData = {
        desiredDueDate: null,
        orderNote: null,
        orderId: ""
      };
      this.orderDocs = [];
      this.allOrderDocs = [];
      this.orderDocsLoading = false;
    },

    cancelOperation() {
      this.$emit("cancelOperation");
    },

    editedOrderNote() {
      if (
        this.editNumberForm.orderNote === null ||
        this.editNumberForm.orderNote === ""
      ) {
        this.editMade = false;
      } else {
        this.editMade = true;
      }
      this.editedOrderData.orderNote = this.editNumberForm.orderNote;
    },

    editCheckAll(value) {
      if (value) {
        console.log("checking all");
        this.editNumberForm.checkedNumbers = [];
        for (let i = 0; i < this.allSummaryNumbers.length; i++) {
          const tn = this.allSummaryNumbers[i].telephoneNumber;
          if (this.editNumberForm.telephoneNumber !== tn) {
            this.editNumberForm.checkedNumbers.push(tn);
          }
        }
      } else {
        this.editNumberForm.checkedNumbers = [];
      }
    },

    async submitNumberEdit() {
      const orderObject = {
        name: this.editNumberForm.name,
        streetNum: this.editNumberForm.streetNum,
        streetName: this.editNumberForm.streetInfo,
        locationType1: this.editNumberForm.locationType,
        locationValue1: this.editNumberForm.locationNumber,
        city: this.editNumberForm.city,
        state: this.editNumberForm.state,
        postalCode: this.editNumberForm.postalCode,
        accountNum: this.editNumberForm.accountNum,
        accountPin: this.editNumberForm.accountPin,
        atn: this.editNumberForm.atn,
        trunkGroup: this.editNumberForm.trunkGroup,
        authName: this.editNumberForm.authName,
        authDate: new Date().toISOString().split("T")[0]
      };

      //First Validate The Order Data Before We Process The Edit.
      await this.$confirm("Process Edits", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel"
      })
        .then(async () => {
          //validate the object first and throw error. if good push to order.
          const params = {
            query: { context: "validateEditObject", formData: orderObject }
          };
          await this.tnPortAvailability(params)
            .then(() => {
              this.processedEdits.push(this.editNumberForm.telephoneNumber);
              this.editMade = true;
              this.editedOrderData[
                this.editNumberForm.telephoneNumber
              ] = orderObject;

              //we will check for any additional numbers and and loop through and add these object too
              const additionalNumbers = this.editNumberForm.checkedNumbers;
              if (additionalNumbers.length) {
                for (let i = 0; i < additionalNumbers.length; i++) {
                  this.editedOrderData[additionalNumbers[i]] = orderObject;
                  this.processedEdits.push(additionalNumbers[i]);
                }
              }

              this.editNumberFormVisible = false;
              this.editNumberForm.checkAll = false;
              this.editNumberForm.checkedNumbers = [];
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.data[0]["message"],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
            });
        })
        .catch(() => true);
    },

    checkOtherChange(value) {
      if (!value) {
        this.editNumberForm.checkAll = false;
      }
      const checkedLength = this.editNumberForm.checkedNumbers.length;
      let editGroupLength = this.allSummaryNumbers.length - 1;

      if (checkedLength === editGroupLength) {
        this.editNumberForm.checkAll = true;
      }
    },

    onDocsUpload(file) {
      this.docs.push(file);
      this.editMade = true;
    },

    fillAddressFields(data) {
      let locationInfo = {
        street_number: "short_name",
        route: "long_name",
        locality: "long_name",
        administrative_area_level_1: "short_name",
        postal_code: "short_name"
      };

      let locationObject = {
        street_number: "",
        route: "",
        locality: "",
        administrative_area_level_1: "",
        postal_code: ""
      };

      for (let i = 0; i < data.length; i++) {
        let addressType = data[i].types[0];
        if (locationInfo[addressType]) {
          locationObject[addressType] = data[i][locationInfo[addressType]];
        }
      }

      this.editNumberForm.streetNum = locationObject["street_number"];
      this.editNumberForm.streetInfo = locationObject["route"];
      this.editNumberForm.city = locationObject["locality"];
      this.editNumberForm.state = locationObject["administrative_area_level_1"];
      this.editNumberForm.postalCode = locationObject["postal_code"];
      this.address =
        locationObject["street_number"] +
        " " +
        locationObject["route"] +
        " " +
        locationObject["locality"] +
        ", " +
        locationObject["administrative_area_level_1"] +
        " " +
        locationObject["postal_code"];

      this.addressFieldsActive = true;
    },

    numberFormatter(val) {
      return val ? phoneNumberFormatter(val) : val;
    },

    prettyNumber(number) {
      return phoneNumberFormatter(number);
    },

    editableNumber(status) {
      const uneditableStatus = ["Complete", "Received FOC", "Canceled"];
      return !uneditableStatus.includes(status);
    },

    editingNumber(item) {
      if (this.editedOrderData.hasOwnProperty(item.telephoneNumber)) {
        this.editNumberFormVisible = true;
        this.address =
          this.editedOrderData[item.telephoneNumber].streetNum +
          " " +
          this.editedOrderData[item.telephoneNumber].streetName +
          " " +
          this.editedOrderData[item.telephoneNumber].city +
          ", " +
          this.editedOrderData[item.telephoneNumber].state +
          " " +
          this.editedOrderData[item.telephoneNumber].postalCode;
        this.editNumberForm.city = this.editedOrderData[
          item.telephoneNumber
        ].city;
        this.editNumberForm.state = this.editedOrderData[
          item.telephoneNumber
        ].state;
        this.editNumberForm.postalCode = this.editedOrderData[
          item.telephoneNumber
        ].postalCode;
        this.editNumberForm.streetNum = this.editedOrderData[
          item.telephoneNumber
        ].streetNum;
        this.editNumberForm.streetInfo = this.editedOrderData[
          item.telephoneNumber
        ].streetName;
        this.editNumberForm.locationType = this.editedOrderData[
          item.telephoneNumber
        ].locationType;
        this.editNumberForm.locationNumber = this.editedOrderData[
          item.telephoneNumber
        ].locationNumber;
        this.editNumberForm.accountNum = this.editedOrderData[
          item.telephoneNumber
        ].accountNum;
        this.editNumberForm.accountPin = this.editedOrderData[
          item.telephoneNumber
        ].accountPin;
        this.editNumberForm.name = this.editedOrderData[
          item.telephoneNumber
        ].name;
        this.editNumberForm.authName = this.editedOrderData[
          item.telephoneNumber
        ].authName;
        this.editNumberForm.atn = this.editedOrderData[
          item.telephoneNumber
        ].atn;
        this.editNumberForm.trunkGroup = item.trunkGroup;
        this.editNumberForm.telephoneNumber = item.telephoneNumber;
      } else {
        this.editNumberFormVisible = true;
        this.address =
          item.streetNum +
          " " +
          item.streetPreDir +
          " " +
          item.streetName +
          " " +
          item.streetType +
          " " +
          item.city +
          ", " +
          item.state +
          " " +
          item.postalCode;
        this.editNumberForm.city = item.city;
        this.editNumberForm.state = item.state;
        this.editNumberForm.postalCode = item.postalCode;
        this.editNumberForm.streetNum = item.streetNum;
        this.editNumberForm.streetInfo =
          item.streetPreDir + " " + item.streetName + " " + item.streetType;
        this.editNumberForm.locationType = item.locationType;
        this.editNumberForm.locationNumber = item.locationNumber;
        this.editNumberForm.telephoneNumber = item.telephoneNumber;
        this.editNumberForm.name = item.name;
        this.editNumberForm.authName = item.authName;
        this.editNumberForm.accountNum = item.accountNum;
        this.editNumberForm.accountPin = item.accountPin;
        this.editNumberForm.atn = item.atn;
        this.editNumberForm.trunkGroup = item.trunkGroup;
      }
    },

    editedPortDate() {
      if (this.editNumberForm.portDate === null) {
        this.editMade = false;
      } else {
        this.editMade = true;
      }
      this.editedOrderData.desiredDueDate = this.editNumberForm.portDate;
    }
  },

  mounted() {
    // ⭐️ Google Autocomplete ⭐️ //
    this.autocomplete_edit = new google.maps.places.Autocomplete(
      document.querySelector("input[name='autoAddressEdit']"),
      { types: ["geocode"] }
    );
    this.autocomplete_edit.setFields(["address_components"]);
    this.autocomplete_edit.setComponentRestrictions({
      country: ["us", "vi", "ca"]
    });
    this.autocomplete_edit.addListener("place_changed", () => {
      let place = this.autocomplete_edit.getPlace();
      let ac = place.address_components;
      this.fillAddressFields(ac, "edit");
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.button-group {
  max-width: 600px;
  margin: 30px auto;
}

.group-number-list {
  max-width: 600px;
  margin: 10px auto;
}

.modal-summary-table {
  max-width: 600px;
  margin: auto;
}

.tn-status-btn {
  padding: 6px 4px;
  margin: 2px 0;
  display: flex;
  justify-content: center;
  font-weight: 700;
}

.form-comment-header,
.order-note,
.order-notes {
  max-width: 600px;
  margin: 5px auto;
  font: {
    size: 11pt;
  }
}

.order-note {
  margin-top: 15px;
}

.order-docs,
.attach-docs,
.vxe-table {
  max-width: 600px;
  margin: 0 auto;
}

.notes-container {
  margin-top: 10px;
  max-height: 250px;
  overflow: auto;
  border: 1px solid #dcdfe6;
  padding: 5px 10px;
}

.number-check-group {
  display: flex;
  flex-wrap: wrap;

  > * {
    flex-basis: 50%;
    margin: 2px 0;
  }

  max-width: 600px;
  margin: auto;
}

.check-all {
  padding-left: 15px;
}

.search-doc-input {
  width: 275px;
}
</style>
